import { IApplicantService } from "../../service/applicant/ApplicantService";

export default class RegisterApplicantInteractor {
  private applicantService: IApplicantService;

  constructor(applicantService) {
    this.applicantService = applicantService;
  }

  async execute(partyId: string) {
    return this.applicantService.registerApplicant(partyId);
  }
}
